import FirmaInspectorClass from "src/app/model/api/datos/firmaInspectorClass";
import DatabaseTable from "src/app/model/database/generic/databaseTable";

export default class FirmasInspectorTable extends DatabaseTable<FirmaInspectorClass> {

    public async getAll(): Promise<FirmaInspectorClass[]> {
        return await this.GetAllRecords()
    }

    public async getById(Id: number): Promise<FirmaInspectorClass> {
        let records = await this.GetRecordsByIndex(0, 1, 'Id', Id, Id)
        if (records.length){
            return records[0]
        }
        return null
    }

    public async getByLocalId(Id: number): Promise<FirmaInspectorClass> {
        let records = await this.GetRecordsById(0, 1, Id, Id)
        if (records.length) {
            return records[0]
        }
        return null
    }

    public async getByOrdenLocalId(OrdenLocalId: number): Promise<FirmaInspectorClass> {
        let records = await this.GetRecordsByIndex(0, 1, 'OrdenLocalId', OrdenLocalId, OrdenLocalId)
        if (records.length) {
            return records[0]
        }
        return null
    }

    public async update(record: FirmaInspectorClass): Promise<number> {
        return await this.UpdateRecord(record)
    }

    public async delete(record: FirmaInspectorClass): Promise<void> {
        if (!record?.LocalId) return
        await this.DeleteRecord(record.LocalId)
    }

}